import { useSettings, useSettingsDispatch } from "../../context/SettingsProvider"
import { useUser } from "../../context/UserProvider";

export default function CommentHeader({id, author, approved}){

	const settings = useSettings();
	const settingsDispatch = useSettingsDispatch();

	const userContext = useUser();

	const commentsAllowed = settings.isCommentsOpen && (!settings.commentRegistration || userContext.type === "logged");

	const onReplyClick = (e) => {
		e.preventDefault();
		const value = settings.expandedReply === id ? null : id;
		settingsDispatch({type:'expandReply', expandedReply: value});
	}

	return (
		<div className='comment--header'>
			<span className='comment--user-info'>
				{author}
			</span>
			{ !approved &&
				<span className='comment--approve-status'>
					Waiting for approval
				</span>
			}
			{
				commentsAllowed && approved &&
				<div className="comment--controls">
					<button
						title='Reply' 
						className='reply-icon comment--control' 
						onClick={onReplyClick}
						disabled={settings.isLoading ? true : false}
					/>
				</div>
			}
		</div>
	)
}